export const PAGINATION_DEFAULT = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10
};

export const DEBOUNCE_TIMES = {
  NAME: 300,
  SLUG: 300
};

export const VALIDATION_MESSAGES = {
  NAME_EMPTY: "Category name cannot be empty",
  NAME_EXISTS: "Category name already exists",
  NAME_ERROR: "Error checking category name",
  NAME_SUCCESS: "Category name is available",
  NAME_INVALID_LENGTH: "Category name must be at least 3 characters long",
  NAME_INVALID_SPACE: "Category name cannot have leading or trailing spaces",
  SLUG_INVALID: "Slugs can only use lowercase and have a '-'",
  SLUG_EXISTS: "Slug already exists, please choose another slug",
  SLUG_SUCCESS: "Valid slug"
};


export const TABLE_COLUMNS = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: "5%",
    align: "center",
    render: (text, record, index) => {
      const { current, pageSize } = record.pagination || {};
      if (current && pageSize) {
        return (current - 1) * pageSize + index + 1;
      }
      return index + 1;
    },
  },
  {
    title: "URL-friendly",
    dataIndex: "slug",
    key: "slug",
    width: "20%",
  },
  {
    title: "Category Name",
    dataIndex: "name",
    key: "name",
    width: "20%",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    width: "40%",
    render: (text) => (
      <div style={{
        wordWrap: "break-word",
        wordBreak: "break-word",
        whiteSpace: "pre-wrap",
        width: "100%",
      }}>
        {text || " "}
      </div>
    ),
  }
];